module.exports = __webpack_public_path__ + "static/media/MadeInUSA.c35d313c.png";